export const StockStatus = [
  {label: '待上架', value: 0, color: '#E6A23C'},
  {label: '正常在库', value: 1, color: '#67C23A'},
  {label: '部分锁定', value: 2, color: '#409EFF'},
  {label: '全部锁定', value: 3, color: '#F56C6C'},
  {label: '已出完', value: 4, color: '#909399'},
]

export const InboundStatus = [
  {label: '已建单', value: 0, color: '#E6A23C'},
  {label: '已确认', value: 1, color: '#409EFF'},
  {label: '入库中', value: 2, color: '#E6A23C'},
  {label: '待确认入库', value: 3, color: '#E6A23C'},
  {label: '已入库', value: 4, color: '#67C23A'},
  {label: '已上架', value: 5, color: '#67C23A'},
]

export const ProductStatus = [
  {label: '良品', value: 1, color: '#67C23A'},
  {label: '不良品', value: 2, color: '#F56C6C'},
  {label: '良品锁定', value: 3, color: '#67C23A'},
  {label: '不良品锁定', value: 4, color: '#F56C6C'},
]

export const OrderCancelStatus = [
  {label: '待处理', value: 0, color: '#E6A23C'},
  {label: '处理中', value: 1, color: '#409EFF'},
  {label: '已处理', value: 2, color: '#67C23A'},
]



// WEBPACK FOOTER //
// ./src/common/constant.js